import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { AppSettings } from '../../../../app.settings';
import { Settings } from '../../../../app.settings.model';
import { MenuService } from '../menu.service';
import { MasterService } from 'src/app/pages/master/master.service';
import { SharedService } from 'src/app/shared/shared.service';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/helpers/auth.services';

@Component({
  selector: 'app-vertical-menu',
  templateUrl: './vertical-menu.component.html',
  styleUrls: ['./vertical-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ MenuService ]
})
export class VerticalMenuComponent implements OnInit {
  @Input('menuItems') menuItems;
  @Input('menuParentId') menuParentId;
  access : any;
  permissiondata: any;
  userAccess:boolean = false;
  productAccess:boolean = false;
  offerAccess:boolean = false;
  comboKitAccess:boolean = false;
  videoAccess:boolean = false;
  cropAccess:boolean = false;
  parentMenu:Array<any>;
  public settings: Settings;
  constructor(public appSettings:AppSettings, 
    public menuService:MenuService, 
    public sharedService:SharedService,
    private router: Router,
    private authenticationService: AuthenticationService) { 
    this.settings = this.appSettings.settings;
  }

  ngOnInit() {     
    this.parentMenu = this.menuItems.filter(item => item.parentId == this.menuParentId); 

    this.getAccess();
  }

  onClick(menuId){
    this.getAccess();
    this.menuService.toggleMenuItem(menuId);
    this.menuService.closeOtherSubMenus(this.menuItems, menuId);    
  }
  // showmenu(title){
  //   let role = localStorage.getItem("role")
  //   if(title == "Users"){
  //     if(role == "ROLE_ADMIN"){
  //       return true;
  //     }
  //     return false;
  //   }
  //   return true;
  // }

  getAccess(){
    const id = localStorage.getItem("userid");
    this.sharedService.getUserPermissionyDetailsById(id).subscribe({
      next: (response) => {
        this.permissiondata = response;
        for (let i = 0; i < response.length; i++) {
          if(response[i].moduleName == "user"){
            this.userAccess = response[i].viewAccess;
          }
          if(response[i].moduleName == "product"){
            this.productAccess = response[i].viewAccess;
          }
          if(response[i].moduleName == "offer"){
            this.offerAccess = response[i].viewAccess;
          }
          if(response[i].moduleName == "combo_kit"){
            this.comboKitAccess = response[i].viewAccess;
          }
          if(response[i].moduleName == "video"){
            this.videoAccess = response[i].viewAccess;
          }
          if(response[i].moduleName == "crop"){
            this.cropAccess = response[i].viewAccess;
          }
          if(!response[0].status){
            this.removeUser();
          }

          // const moduleName = response[i].moduleName;
          // localStorage.setItem(moduleName+"Add", response[i].addAccess);
          // localStorage.setItem(moduleName+"Edit", response[i].editAccess);
        }
      }
    });
  }

  removeUser() {
    window.sessionStorage.removeItem('currentUser');
    window.localStorage.clear();
     this.router.navigate(['/landing']);
     this.authenticationService.logout();
   }

  showmenu(title){
    // this.getAccess();

    if(title == "User Management"){
      return this.userAccess;
    }
    if(title == "Product Management"){
      return this.productAccess;
    }
    // if(title == "Product Category"){
    //   return JSON.parse(localStorage.getItem("productAccess"));
    // }
    // if(title == "Product"){
    //   return JSON.parse(localStorage.getItem("productAccess"));
    // }
    // if(title == "State Wise Product"){
    //   return JSON.parse(localStorage.getItem("productAccess"));
    // }
    // if(title == "UOM"){
    //   return JSON.parse(localStorage.getItem("productAccess"));
    // }
    if(title == "Crop Management"){
      return this.cropAccess;
    }

    if(title == "Advertise Management"){
      return this.cropAccess;
    }
    if(title == "Offer Management"){
      return this.offerAccess;
    }
    if(title == "Kit BOM"){
      return this.comboKitAccess;
    }
    if(title == "Integrated video"){
      return this.videoAccess;
    }
    return true;
  }

  // showSubmenu(title){
  //   console.log(title);
  //   if(title == "Offer Management"){
  //     return this.offerAccess;
  //   }
  //   return true;
  // }

}
